export const DARK_MODE_PREFERENCE_MAP_KEY = 'pc-user-preferences-dark-mode';
export const LANGUAGE_PREFERENCE_MAP_KEY = 'pc-user-preferences-language';

const normalizeScopeValue = (value) => String(value || '').trim().toLowerCase();

export const getUserPreferenceScope = (user) => {
  if (!user || typeof user !== 'object') {
    return 'anonymous';
  }

  const candidates = [
    user.uid,
    user.user_id,
    user.sub,
    user.email,
    user.preferred_username,
    user.upn,
    user.name,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeScopeValue(candidate);
    if (normalized) {
      return normalized;
    }
  }

  return 'anonymous';
};

export const normalizePreferenceMap = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }
  return value;
};

export const collectPreferenceEntriesForLogout = () => {
  const keysToPreserve = [DARK_MODE_PREFERENCE_MAP_KEY, LANGUAGE_PREFERENCE_MAP_KEY];
  const entries = [];

  keysToPreserve.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      entries.push([key, value]);
    }
  });

  return entries;
};

export const restorePreferenceEntriesAfterLogout = (entries = []) => {
  entries.forEach(([key, value]) => {
    if (typeof key === 'string' && value !== null && value !== undefined) {
      localStorage.setItem(key, value);
    }
  });
};
